import { ApiClient } from '../../ApiClient';
import { ConnectorDTO, ConnectionDTO } from '../dto/MarketplaceDTOs';

export class ConnectionsDataSource {

  constructor(private api: ApiClient) {
  }

  async fetchConnectors(type?: string): Promise<ConnectorDTO[]> {
    const response = await this.api.get<ConnectorDTO[]>('/connections/connectors', {
      params: {
        type: type
      }
    });
    return response.data;
  }

  async fetchConnections(): Promise<ConnectionDTO[]> {
    const response = await this.api.get<ConnectionDTO[]>('/connections');
    return response.data;
  }

  async removeConnection(connectionId: string): Promise<void> {
    await this.api.delete(`/connections/${connectionId}`);
  }
}
